import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M14 2v6h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m3 12.5 5 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 12.5-5 5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileX2";
const FileX2 = memo(themed(Icon));
export {
  FileX2
};
//# sourceMappingURL=file-x-2.js.map
